import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=da118c74&scoped=true&"
import script from "./Prize.vue?vue&type=script&lang=js&"
export * from "./Prize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da118c74",
  null
  
)

export default component.exports